import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  ButtonComponent, FieldValidationDirective, ResolvableModal } from '@softline/ui-core';
import { DateInputComponent } from '@softline/ui-core/date-input';

export interface ExportDialogResult {
  beginDate: string;
  endDate: string;
}

@Component({
  selector: 'soft-dn-roster-export-dialog',
  imports: [ReactiveFormsModule, ButtonComponent, DateInputComponent, FieldValidationDirective],
  templateUrl: './export-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ExportDialogComponent extends ResolvableModal<ExportDialogResult | 'CANCEL'> {
  readonly form = new FormGroup({
    from: new FormControl<string | null>(null, Validators.required),
    to: new FormControl<string | null>(null, Validators.required),
  });

  export(): void {
    if (this.form.invalid) return;
    const v = this.form.getRawValue();
    this.resolve({ beginDate: v.from as string, endDate: v.to as string });
  }

  cancel(): void {
    this.resolve('CANCEL');
  }
}
